module.exports = __webpack_public_path__ + "media/images/user-on-phone-170e745d.png";